<template>
	<div
		class="siege-the-target"
		:class="{ 'is-disabled': isDisabled }"
		@click="onClick"
	>
		<div class="siege-the-target__left">
			<div class="target icon-light-aim_sight-32">1</div>
			<div class="text">{{ translate("ui.regular_attack") }}</div>
		</div>
		<div class="siege-the-target__right">
			<div class="damage-value">-{{ siegeDamage }}</div>
			<AppMainIcon iconName="hearth" :iconSize="16" />
			<div class="damage-time">/10s</div>
			<input
				type="checkbox"
				id="siege_activation"
				:checked="isActive"
				:disabled="isDisabled"
			/>
		</div>
	</div>
</template>

<script lang="ts" setup>
import AppMainIcon from "@/components/AppMainIcon.vue";
import type TileEntity from "@/game/entities/TileEntity.ts";
import useSiegeSystemRepository from "@/hooks/useSiegeSystemRepository.ts";
import { translate } from "@/utils/translate";
import { computed, markRaw } from "vue";

const { entity } = defineProps<{
	entity: TileEntity;
}>();

const ssr = markRaw(useSiegeSystemRepository());

const isActive = computed<boolean>((): boolean =>
	ssr.isSiegeTargetByTileIndex(entity.index),
);

const isDisabled = computed<boolean>(
	(): boolean => !ssr.canPerformFriendlyActionByTileIndex(entity.index),
);

const siegeDamage = computed<number | null>((): number | null =>
	ssr.getFriendlyDamage(
		entity.index,
		// 1 + useSiegeSystemStore().offlineBoostersAvailableForUse,
	),
);

const onClick = (): void =>
	ssr[
		isActive.value
			? "removeSiegeTargetByTileIndex"
			: "addSiegeTargetByTileIndex"
	](entity.index);
</script>

<style lang="scss" scoped>
.siege-the-target {
	gap: 0.25rem;
	box-shadow: inset 0 0 0.5rem 0 rgba(0, 0, 0, 0.3);
	border: solid 0.075rem rgb(25, 179, 69);
	background-image: linear-gradient(to top, rgb(24, 26, 29), rgb(48, 50, 57));
	padding: 0.5rem;
	width: 100%;
	@include flex-row-between;
	color: rgb(255, 243, 221);
	font-weight: 800;
	font-size: 1.0625rem;

	&__left {
		@include flex-row-start;
		gap: 0.5rem;
		font-weight: bold;

		.target {
			@include flex-row-center;
			padding-bottom: 0.125rem;
			color: #19b345;
		}
		.text {
			padding-bottom: 0.25rem;
		}
	}
	&__right {
		@include flex-row-start;
		gap: 0.25rem;
		font-weight: bold;

		input {
			margin-left: 0.25rem;
			width: 2rem;
			height: 2rem;

			&::before {
				width: 1.675rem;
				height: 1.675rem;
			}
		}

		.damage-value {
			padding-bottom: 0.25rem;
		}
		.damage-time {
			padding-bottom: 0.0625rem;
			font-weight: normal;
			font-size: 0.8125rem;
		}
	}

	&.is-disabled {
		opacity: 0.5;
		pointer-events: none;
	}
}
</style>
